export enum RegisterAccountType {
  Supplier = 1,
  HoReCa = 2,
  Retailer = 3
}

(RegisterAccountType as any).__typeName = 'RegisterAccountType';
